import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Form } from '@unform/web';

import { useAuth } from '../../hooks/auth';
import { useDarkMode } from '../../hooks/darkMode';

import {
  IconMail,
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandYoutube,
  IconSettings,
  IconBrandWhatsapp,
  IconChevronRight,
  IconHelp,
  IconLogout,
} from '@tabler/icons';

import Header from '../../components/Header';
import BottomNav from '../../components/BottomNav';
import SwitchInput from '../../components/Form/SwitchInput';
import { SimpleButton } from '../../components/Generic';
import {
  Container,
  Content,
  AvatarContainer,
  Name,
  Bio,
  Card,
  IconContainer,
} from './styles';

import userImg from '../../assets/images/user-avatar.png';

const Profile: React.FC = () => {
  const { signOut, user } = useAuth();
  const { toggleDarkMode, isDark } = useDarkMode();
  const history = useHistory();

  return (
    <Container>
      <Header />

      <Content>
        <AvatarContainer>
          <img src={user.url || userImg} alt="Foto" />

          <IconContainer onClick={() => history.push('/perfil/editar')}>
            <IconSettings size={24} />
          </IconContainer>
        </AvatarContainer>

        <Name>{user.nome}</Name>
        <Bio>{user.formacao_profissional}</Bio>

        <Card>
          <label>Social</label>

          {user.email && (
            <a href={`mailto:${user.email}`}>
              <IconMail size={25} /> {user.email}
            </a>
          )}

          {user.whatsapp_numero && (
            <a
              href={`https://api.whatsapp.com/send?phone=+55${user.whatsapp_numero.replaceAll(
                ' ',
                '',
              )}`}
            >
              <IconBrandWhatsapp size={25} /> WhatsApp
            </a>
          )}

          {user.facebook_nome && (
            <a
              href={`https://www.facebook.com/${user.facebook_nome.replace(
                '@',
                '',
              )}`}
            >
              <IconBrandFacebook size={25} /> Facebook
            </a>
          )}

          {user.instagram_nome && (
            <a
              href={`https://www.instagram.com/${user.instagram_nome.replace(
                '@',
                '',
              )}`}
            >
              <IconBrandInstagram size={25} /> Instagram
            </a>
          )}

          {user.youtube_link && (
            <a href={`${user.youtube_link}`}>
              <IconBrandYoutube size={25} /> YouTube
            </a>
          )}
        </Card>

        <br />

        <Card>
          <label>Opções</label>

          <Form style={{ padding: '0 16px 0 16px' }} onSubmit={() => null}>
            <SwitchInput
              name="isDark"
              label="Modo escuro"
              defaultChecked={isDark}
              onChange={() => toggleDarkMode()}
            />
          </Form>

          <SimpleButton type="button" onClick={() => history.push('/ajuda')}>
            <div>
              <IconHelp size={25} style={{ marginRight: 20 }} />
              Ajuda
            </div>

            <IconChevronRight size={25} />
          </SimpleButton>

          <SimpleButton type="button" onClick={() => signOut()}>
            <div>
              <IconLogout size={25} style={{ marginRight: 20 }} />
              Sair
            </div>

            <IconChevronRight size={25} />
          </SimpleButton>
        </Card>
      </Content>

      <BottomNav selected="profile" />
    </Container>
  );
};

export default Profile;
